import React from 'react'
import { Layout} from 'antd';
const { Footer } = Layout;

export default function AdminFooter() {
    return (
        <Footer className="admin-footer">Copyright Tien Len Steel Corporation Joint Stock Company. All rights reserved</Footer>
    )
}
